import { RepositoryFactory } from '@/api/RepositoryFactory'
import { initialPagination } from '@/datas/Pagination'
import { isObject } from 'element-ui'
import { preparePagination } from '@/helpers/store'

const API = RepositoryFactory.get('registerOfPayments')
const apiFlights = RepositoryFactory.get('responses')
const Doc = RepositoryFactory.get('doc')

export default {
  namespaced: true,
  state: {
    registerData: [],
    response: {},
    acts: [],
    pagination: initialPagination,
    loading: true,
  },
  getters: {
    getRegisterData: state => state.registerData,
    getResponse: state => state.response,
    getItems: state => (id, type) =>
      state[type].filter(p => p.response_id === id),
    getLoading: state => state.loading,
    getRegisterPagination: state => state.pagination,
  },
  actions: {
    fetchRegisterData({ commit }, settings) {
      commit('setLoading', true)

      API.getRegisterData(settings)
        .then(({ data, headers }) => {
          commit('setPagination', preparePagination(headers))
          commit('setRegisterData', data)
        })
        .catch(error => console.log(error))
        .finally(() => commit('setLoading', false))
    },
    fetchRegisterItem({ commit }, settings) {
      commit('setLoading', true)

      API.getRegisterData(settings)
        .then(({ data }) => {
          commit('updateRegisterItem', data.length > 1 ? data : {})
        })
        .catch(error => console.log(error))
        .finally(() => commit('setLoading', false))
    },
    fetchFlight({ commit, dispatch }, search) {
      commit('setLoading', true)

      return apiFlights
        .fetchFlights(search)
        .then(({ data }) => {
          const flight = data.responses[0]

          if (flight?.id) {
            dispatch('fetchFlightsActs', flight.id)
          }
          commit('setResponse', flight)
        })
        .catch(e => console.log(e))
        .finally(() => commit('setLoading', false))
    },
    fetchFlightsActs({ commit }, id) {
      commit('setLoading', true)

      Doc.getDocument('responses', id, 'works_act')
        .then(res =>
          commit('setActs', [
            ...res.data.map(d => ({ ...d, response_id: id })),
          ]),
        )
        .catch(e => console.log(e))
        .finally(() => commit('setLoading', false))
    },
  },
  mutations: {
    setRegisterData(state, payload) {
      state.registerData = payload
    },
    setPagination(state, payload) {
      state.pagination = payload
    },
    updateRegisterItem(state, item) {
      if (item.length === 1 && item[0].bid_id) {
        const index = state.registerData.findIndex(
          i => i.bid_id === item[0].bid_id,
        )

        if (index !== -1) {
          state.registerData.splice(index, 1, item[0])
        }
      }
      if (item.length > 1) {
        item.map(x => {
          if (x.bid_id) {
            const index = state.registerData.findIndex(
              i => i.bid_id === x.bid_id,
            )

            if (index !== -1) {
              state.registerData.splice(index, 1, x)
            }
          }
        })
      }
    },
    setResponse(state, flight) {
      state.response = flight
    },
    setActs(state, acts) {
      state.acts = acts
    },
    setLoading(state, payload) {
      state.loading = payload
    },
  },
}
